export default __webpack_public_path__ + "static/media/imgGold.2f13ffa3.png";